<template>
  <v-hover v-slot="{hover}">
      <div class="pt-4" v-if="section.isImage" >

        <v-row  no-gutters  style="flex-wrap: nowrap; height: 100% !important" class="fill-height"  >

          <!-- Drag Icon-->
          <v-col style=" height: 100% !important;" class="flex-grow-0 flex-shrink-0 sideTransition fill-height">
            <v-sheet color="transparent" width="32" class="editor-section-drag">
              <v-icon v-if="hover"  style="cursor: grab"  :color="wsACCENT">
                mdi-drag-vertical
              </v-icon>
            </v-sheet>
          </v-col>
          <!-- Section Content -->
          <v-col style="min-width: 100px; max-width: 100%;" class="flex-grow-1 flex-shrink-0">

            <!-- Image -->
            <v-img
                v-if="section.url"
                :src="section.url"
                class="wsRoundedLight"
                transition="xxx"
            />

            <!-- File Uploader -->
              <div v-else class="py-4" style="width: 100%">
                <ws-file-uploader public :lang="lang" :superadmin="superadmin" image @success="updateImage"   />
              </div>

          </v-col>
          <!-- Section Edit Buttons -->
          <v-col style=" height: 100% !important;" class="flex-grow-0 flex-shrink-0 sideTransition fill-height">
            <v-sheet width="32" color="transparent" class="pl-1 fill-height " >
              <ft-select
                  @input="$emit('edit',$event)"
                  :items="editActionsSelect">
                <ws-icon-button v-if="hover" small   />
              </ft-select>
            </v-sheet>
          </v-col>

        </v-row>

      </div>
  </v-hover>

</template>

<script>
export default {
  name: "editorSectionImage",
  props : {
    value : {
      type : Object
    },
    section : {},
    lang : {
      type : String,
      default : 'ua',
    },
    superadmin : {
      type : Boolean,
      default : false
    }
  },
  computed : {
    editActionsSelect() {
      return [
        { text : this.$t('Duplicate') , value: 'duplicate' , icon : 'mdi-content-copy' },
        { text : this.$t('Delete') , value: 'delete' , icon : 'mdi-delete-outline' },
      ];
    },
  },
  methods : {
    updateImage($event) {
      this.section.url = $event.url
      this.$emit('input', this.section)
    }
  },
  mounted() {
    if (this.value) {
      this.section = this.value
    }
  }
}
</script>

<style scoped>

</style>